<template>
  <main class="flex-1 flex flex-col overflow-hidden">
    <!-- <Header :title="dataType == 'facebook' ? showLang[selectLang]['views']['List']['page_name'] : showLang[selectLang]['views']['List']['tiktok_page_name']" @childLang="useLang"> -->
    <Header :title="showLang[selectLang]['views']['TargetList']['page_name']" @childLang="useLang">
      <div v-if="false" class="mx-4 text-gray-700">
        {{showTiktokLang[selectLang]['views']['List']['advertising_source']}}
      </div>
      <div v-if="false" class="mx-1 text-gray-400">
        <Dropdown
          v-model="fromAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="fromAccountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          class="w-36 ml-2s rounded-md"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center">
              <img v-if="slotProps.value == 'facebook'" :alt="slotProps.value" width="28" src="https://dev-private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.value == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.value" width="25" src="https://dev-private.autoturn.net/img/tiktok_icon.png"/>
              <div v-if="slotProps.value == 'facebook'" class="leading-7">Facebook</div>
              <div v-if="slotProps.value == 'tiktok'" class="leading-7">Tiktok</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center">
              <img v-if="slotProps.option.code == 'facebook'" class="-ml-0.5" :alt="slotProps.option.name" width="28" src="https://dev-private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.option.code == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.option.name" width="25" src="https://dev-private.autoturn.net/img/tiktok_icon.png"/>
              <div class="leading-7">{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div v-if="dataType == 'facebook'" class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['List']['advertise_account_text']}}
      </div>
      <div v-if="dataType == 'facebook'" class="mx-1 text-gray-400">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          class="w-52 ml-2s rounded-md h-12 leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(accountSelect)"
        />
      </div>
      <div v-if="dataType == 'tiktok'" class="mx-4 text-gray-700">
        {{showTiktokLang[selectLang]['views']['List']['account_name']}}
      </div>
      <div v-if="dataType == 'tiktok'" class="mx-1 text-gray-400">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showTiktokLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          class="w-52 ml-2s rounded-md h-12 leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(accountSelect)"
        />
      </div>
      <span
        class="focus:outline-none rounded-xl leading-9 px-4 py-1 ml-4 text-gray-500 transition duration-500 ease-in-out mr-2 h-12 font-bold"
        :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
      >
        {{showLang[selectLang]['views']['List']['campaign_run_info']}}{{run_info}}
      </span>
    </Header>
    <section class="flex justify-between items-center py-2 px-2 bg-white">
      <button
        class="lg:block md:block hidden bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 ml-4 text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400 mr-2"
        :class="{ 'ring-4 border-blue-400': nowStep === 10 || nowStep === 90 }"
        :style="nowStep == 10 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null"
        :disabled="isUes"
        @click="createCampaign()"
      >
        {{createText}}
      </button>
    </section>

    <!-- <Test /> -->

    <!-- <section class="flex overflow-x-hidden bg-gray-200"> -->
    <section class="flex bg-gray-200">
      <main id="edit_content" ref="scrollcontent" class="w-11/12 mx-auto pt-16 pr-16 overflow-y-scroll flex flex-row flex-wrap" style="height: 85vh;">
        <div v-if="false" class="w-full flex flex-row flex-wrap items-start">
          <EventsListChart v-bind:showChart="showChart" :title="`${showLang[selectLang]['views']['List']['events_list_chart_title']}`" :chartsData="lineStylesData" :guideStep="nowStep" />
          <EventsListWordcloud v-bind:showCloud="showCloud" v-bind:viewDatalist="keywordsList" v-bind:adaccountIdSelect="accountSelect" v-bind:lang="showLang[selectLang]" :guideStep="nowStep"/>
        </div>

        <div v-if="false" class="w-full flex flex-row flex-wrap items-start">
          <TikTokEventsListChart v-bind:showChart="showChart" :title="`${showLang[selectLang]['views']['List']['tiktok_events_list_chart_title']}`" :chartsData="lineStylesData" :guideStep="nowStep" />
          <TikTokEventsListWordcloud v-bind:showCloud="showCloud" v-bind:viewDatalist="keywordsList" v-bind:adaccountIdSelect="accountSelect" v-bind:lang="showTiktokLang[selectLang]" :guideStep="nowStep"/>
        </div>

        <div v-if="dataType == 'facebook'" class="w-full flex flex-row flex-wrap items-start mt-3" :style="nowStep == 9 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null">
          <ListDataTable v-bind:showTable="showTable" v-bind:selecdedCurrency="selecdedCurrency" v-bind:viewDatalist="campaignListData" v-bind:fromAccountSelect="fromAccountSelect" v-bind:parentMemberInfo="memberInfo" v-bind:lang="showLang[selectLang]"/>
        </div>

        <div v-if="false" class="w-full flex flex-row flex-wrap items-start mt-3" :style="nowStep == 9 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null">
          <TikTokListDataTable v-bind:showTable="showTable" v-bind:selecdedCurrency="selecdedCurrency" v-bind:viewDatalist="campaignListData" v-bind:fromAccountSelect="fromAccountSelect" v-bind:parentMemberInfo="memberInfo" v-bind:lang="showTiktokLang[selectLang]"/>
        </div>
      </main>
    </section>
  </main>

  <div v-if="nowStep >= 7 && nowStep <= 9 || nowStep == 90" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0); z-index: 1100;"></div>

  <Mask :isDisplay="nowStep > -1" />
  <ListMask
    v-if="nowStep >= 7 && nowStep <= 10 || nowStep == 90"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
    @closeForTeaching="doCloseForTeaching"
  />

  <!-- 固定右下角的 SVG 按鈕 -->
  <div v-if="false" class="fixed bottom-20 right-8 flex flex-col items-end space-y-2" style="z-index:1105;">
    <div
      v-if="showBox"
      class="bg-white border rounded-lg shadow-xl p-4"
      style="width:600px; height: 600px;"
    >
      <!-- Header -->
      <div class="flex justify-between items-center mb-2">
        <div class="flex">
          <span class="font-semibold text-blue-600" style="font-size:24px;">廣告優化建議</span>
          <div class="text-gray-600 text-xs ml-4 mt-1">
            <InputSwitch v-model="openAutoStatus" class="-my-1 mt-1" />
            <span class="mx-1">開啟後，系統將默認針對所有行銷活動進行自動執行的動作。</span>
          </div>
        </div>
        <button @click="showBox = false" class="text-gray-500 hover:text-black text-xl leading-none">×</button>
      </div>

      <div class="overflow-y-auto" style="height: 520px;">
        <div v-for="(itemData, itemIndex) in campaignList" :key="itemIndex" class="border p-4 my-2" style="border-left: 6px solid #A7B6FC; border-radius: 8px; background-color:#E0E7FF;">
          <div>
            <div class="grid grid-cols-12 text-xs text-gray-700 cursor-pointer" @click="toggleBlock(itemIndex)">
              <div class="col-span-11 text-lg font-semibold">{{itemData.name}}</div>
              <div class="text-sm text-right">
                <span class="text-blue-600">
                  {{ itemData.status ? '▲' : '▼' }}
                </span>
              </div>
              <div class="col-span-12 text-left">曝光 12,000｜點擊率 2.5%｜轉換 120｜預算 $1,000</div>
            </div>
            <div v-if="itemData.status">
              <div class="my-2 text-right">
                <button class="px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600">自動執行</button>
                <button class="px-3 py-1 ml-2 bg-gray-300 text-gray-700 text-sm rounded hover:bg-gray-400">略過</button>
              </div>

              <div class="bg-white rounded-md p-2">
                <!-- 優化建議 - 預算調整 -->
                <div v-if="itemIndex == 0" class="border p-4 my-2" style="border-left: 6px solid #fbbf24; border-radius: 8px;">
                  <div class="flex justify-between items-center">
                    <div class="text-white text-xs px-1.5 py-1 rounded-xl" style="background-color:#fbbf24;">預算調整</div>
                  </div>
                  <div class="mt-2 text-sm">
                    <p class="mb-1"><span class="font-semibold">優化方向：</span>提升高成效組合預算，降低低表現組合支出。</p>
                    <p class="mb-1"><span class="font-semibold">目前狀態：</span><span style="color:#DC2626;" class="font-semibold">{{ stageList[stageData.currentStage].title }}</span> → <span style="color:#16A34A;" class="font-semibold">{{ stageList[stageData.targetStage].title }}</span></p>
                    <p class="mb-1"><span class="font-semibold">調整結果：</span></p>
                    <div class="border rounded-md p-2 mb-1 overflow-y-auto" style="max-height:150px;">
                      <div v-for="(group, idx) in budgetGroups" :key="idx" class="flex justify-between mb-1">
                        <span>{{ group.name }}</span>
                        <span>前：{{ group.before }} → 後：{{ group.after }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 優化建議 - 關鍵字分裂 -->
                <div v-if="itemIndex == 1" class="border p-4 my-2" style="border-left: 6px solid #F472B6; border-radius: 8px;">
                  <div class="flex justify-between items-center">
                    <div class="text-white text-xs px-1.5 py-1 rounded-xl" style="background-color:#F472B6;">關鍵字分裂</div>
                  </div>
                  <div class="mt-2 text-sm">
                    <p class="mb-1"><span class="font-semibold">優化方向：</span>透過不同關鍵字，增加廣告曝光，找出合適的投遞方向。</p>
                    <p class="mb-1"><span class="font-semibold">目前狀態：</span><span style="color:#DC2626;" class="font-semibold">{{ stageList[stageData.currentStage].title }}</span> → <span style="color:#16A34A;" class="font-semibold">{{ stageList[stageData.targetStage].title }}</span></p>
                    <p class="mb-1"><span class="font-semibold">調整結果：</span></p>
                    <div class="overflow-y-auto" style="max-height:150px;">
                      <div v-for="(group, idx) in keywordGroups" :key="idx" class="border rounded-md p-2 mb-1">
                        <div class="font-medium">{{ group.name }}</div>
                        <div class="text-sm mb-1 text-gray-600">現用關鍵字：</div>
                        <div class="flex flex-wrap mb-2">
                          <span
                            v-for="(word, cIdx) in group.current"
                            :key="cIdx"
                            class="rounded m-1 px-1 py-1 text-xs bg-gray-200 text-gray-600"
                          >
                            {{ word }}
                          </span>
                        </div>

                        <div class="text-sm mb-1 text-gray-600">建議替換關鍵字：</div>
                        <div class="flex flex-wrap">
                          <span
                            v-for="(word, sIdx) in group.suggest"
                            :key="sIdx"
                            class="rounded m-1 px-1 py-1 text-xs bg-blue-400 text-white"
                          >
                            {{ word }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <!-- 數據 -->
      
    </div>
    <div class="bot-fab" id="botFab" @click="showBox = !showBox">
      <svg viewBox="0 0 24 24" fill="none"><path d="M12 2a2 2 0 0 1 2 2v1.09A7.001 7.001 0 0 1 19 12v1.5c0 .83-.67 1.5-1.5 1.5h-.55a4.5 4.5 0 0 1-8.9 0H6.5A1.5 1.5 0 0 1 5 13.5V12a7.001 7.001 0 0 1 5-6.91V4a2 2 0 0 1 2-2Zm0 16a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 18Z" fill="currentColor"/></svg>
      <span v-if="!showBox" class="red-dot" id="redDot"></span>
    </div>
  </div>
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import ListMask from '@/components/Mask/ListMask.vue';

import Dropdown from 'primevue/dropdown'
import Header from '@/components/Header.vue'
import InputSwitch from 'primevue/inputswitch';
import Test from '@/components/Event/Test.vue'
import EventsListChart from '@/components/TargetList/EventsListChart.vue'
import EventsListWordcloud from '@/components/TargetList/EventsListWordcloud.vue'
import ListDataTable from '@/components/TargetList/ListDataTable.vue'
import TikTokEventsListChart from '@/components/TikTokList/EventsListChart.vue'
import TikTokEventsListWordcloud from '@/components/TikTokList/EventsListWordcloud.vue'
import TikTokListDataTable from '@/components/TikTokList/ListDataTable.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'

// import { ref } from 'vue';

export default {
  name: 'TargetList',
  components: {
    Mask,
    ListMask,
    Header,
    InputSwitch,
    Test,
    Dropdown,
    EventsListChart,
    EventsListWordcloud,
    ListDataTable,
    TikTokEventsListChart,
    TikTokEventsListWordcloud,
    TikTokListDataTable,
  },
  props: {
    getFirstLoginStatus: {
      type: Array
    },
    getTransmitFbNum: {
      type: String,
      default: ''
    },
    getTransmitTiktokNum: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      nowStep: -1,
      fromAccountSelect: 'facebook',
      fromAccountOptions: [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}],
      dataType: 'facebook',
      accountSelect: '',
      accountOptions: [],
      selecdedCurrency: null,
      allLoading: true,
      showChart: false,
      showCloud: false,
      showTable: false,
      eventSelect: '',
      eventOptions: [],
      tableData: [],
      lineStylesData: {
        datasets: []
      },
      keywordsList: [],
      campaignListData: [],
      run_info: '-/-',
      createText: '請稍候...',
      isUes: true,
      member_source: 0,
      memberInfo: {
        status: 'y',
        plan_id: 1,
        source: 0,
      },
      openAutoStatus: false,
      showBox: false,
      showBlock: false,
      showBudget: false,
      showKeyword: false,
      campaignList: [
        { name: "行銷活動名稱01", status: false},
        { name: "行銷活動名稱02", status: false},
      ],
      stageList:[
        { title: "極差" },
        { title: "待加強" },
        { title: "普通" },
        { title: "良好" },
        { title: "極佳" },
      ],
      stageData: {
        currentStage: 2,
        targetStage: 3
      },
      budgetGroups: [
        { name: '廣告組合 A', before: '$500', after: '$800' },
        { name: '廣告組合 B', before: '$300', after: '$200' },
        { name: '廣告組合 C', before: '$700', after: '$1000' },
        { name: '廣告組合 D', before: '$400', after: '$300' },
        { name: '廣告組合 E', before: '$600', after: '$700' },
      ],
      keywordGroups: [
        {
          name: '廣告組合 A',
          current: ['黑色運動鞋', '運動鞋男1', '運動鞋男2', '運動鞋男3', '運動鞋男4'],
          suggest: ['黑鞋男', '黑鞋女1', '黑鞋女2', '黑鞋女3', '黑鞋女4'],
        },
        {
          name: '廣告組合 B',
          current: ['折扣優惠1','折扣優惠2','折扣優惠3','折扣優惠4','折扣優惠5'],
          suggest: ['限時折扣', '今日特價1', '今日特價2', '今日特價3', '今日特價4'],
        },
      ],
    }
  },
  created() {
    console.log('list created');

    let _tmp_params_id = this.$route.params.id;
    let _tmp_hash = _tmp_params_id.split("_");
    let hash = _tmp_hash[0];
    let link_type = _tmp_hash.pop();
    let routeType = this.$route.params.type;

    console.log(_tmp_hash);
    console.log(hash);
    console.log(link_type);

    console.log('router type');
    console.log(routeType);

    if(routeType != '' && routeType != null && typeof routeType != 'undefined'){
      if(routeType == 't'){
        this.fromAccountSelect = 'tiktok';
        this.dataType = 'tiktok';
      }
    }

    if(hash != '' && hash != null && typeof hash != 'undefined'){
      console.log('props this.getFirstLoginStatusData');
      console.log(this.getFirstLoginStatusData);

      // axios
      //   .post('https://test.autoturn.net/inside/api/member_info.php', Qs.stringify({
      //     s_code: hash,
      //   }))
      //   .then((adResponse) => {
      //     // console.log('adResponse:'+adResponse.data.selecded_data);
      //     console.log('list member_info.php');
      //     if(adResponse.data.status == 'success'){
      //       if(adResponse.data.return_data.first_login == 'Y'){
      //         this.nowStep = 7;
      //       }
      //     }
      //   });

      console.log('created fromAccountSelect');
      console.log(this.fromAccountSelect);

      axios
        .post('https://test.autoturn.net/inside/api/member_info.php', Qs.stringify({
          s_code: this.$route.params.id,
        }))
        .then((adResponse) => {
          // console.log('adResponse:'+adResponse.data.selecded_data);
          console.log('sidebar member_info.php');
          if(adResponse.data.status == 'success'){
            this.member_source = adResponse.data.return_data.source;

            this.memberInfo = {
              status: adResponse.data.return_data.account_status,
              plan_id: adResponse.data.return_data.payment_plan_id,
              source: adResponse.data.return_data.source,
            };

            if(adResponse.data.return_data.fb_in_use_num > 0 && adResponse.data.return_data.tiktok_in_use_num > 0){
              this.fromAccountOptions = [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}];
            }

            if(adResponse.data.return_data.fb_in_use_num > 0 && adResponse.data.return_data.tiktok_in_use_num == 0){
              this.fromAccountOptions = [{"name":"Facebook","code":"facebook"}];
            }

            if(adResponse.data.return_data.fb_in_use_num == 0 && adResponse.data.return_data.tiktok_in_use_num > 0){
              this.fromAccountOptions = [{"name":"Tiktok","code":"tiktok"}];

              this.fromAccountSelect = 'tiktok';
            }

            axios
              .post('https://test.autoturn.net/inside/api/member_campaign_use_num.php', Qs.stringify({
                s_code: this.$route.params.id,
                typs: this.fromAccountSelect
              }))
              .then((response) => {
                // console.log('caResponse:'+caResponse.data.return_data);
                if(response.data.status == 'success'){
                  this.run_info = response.data.return_data
                }
              });

            if(this.fromAccountSelect == 'facebook'){
              console.log('get fb');

              axios
                .post('https://test.autoturn.net/inside/api/campaign_adaccounts.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                }))
                .then((adResponse) => {
                  // console.log('adResponse:'+adResponse.data.selecded_data);
                  if(adResponse.data.status == 'success'){
                    if(adResponse.data.return_data.length > 0){
                      console.log('this.accountOptions');
                      console.log(this.accountOptions);

                      this.accountOptions = adResponse.data.return_data
                      this.accountSelect = adResponse.data.selecded_data
                      this.selecdedCurrency =  adResponse.data.selecded_currency

                      this.createText = this.showLang[this.selectLang]['views']['TargetList']['create_campaign_button_text'];
                      this.isUes = false;

                      if(this.dataType == 'tiktok'){
                        this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                      }

                      // console.log('created this.selecdedCurren:'+this.selecdedCurren);

                      // console.log('this.accountSelect');
                      // console.log(this.accountSelect);

                        axios
                          .post('https://test.autoturn.net/inside/api/target/campaign/campaign_list.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            adaccount_id: this.accountSelect,
                          }))
                          .then((caResponse) => {
                            // console.log('caResponse:'+caResponse.data.return_data);
                            if(caResponse.data.status == 'success'){
                              this.campaignListData = caResponse.data.return_data
                            }

                            this.showTable = true;
                          });

                      // axios
                      //   .post('https://test.autoturn.net/inside/api/target/campaign/campaign_list.php', Qs.stringify({
                      //     s_code: this.$route.params.id,
                      //     adaccount_id: adResponse.data.selecded_data,
                      //   }))
                      //   .then((caResponse) => {
                      //     // console.log('caResponse:'+caResponse.data.return_data);
                      //     if(caResponse.data.status == 'success'){
                      //       this.campaignListData = caResponse.data.return_data
                      //     }

                      //     this.showTable = true;
                      //   });

                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_title'],
                        text: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_text'],
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['confirm_button']
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                        } else if (result.isDenied) {
                          window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                        }
                      })
                    }
                  }
                });
            } else {
              console.log('get tiktok');

              axios
                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  advertiser_id: this.$route.params.adaccount_id,
                }))
                .then((adResponse) => {
                  // console.log('adResponse:'+adResponse.data.selecded_data);
                  if(adResponse.data.status == 'success'){
                    if(adResponse.data.return_data.length > 0){
                      this.accountOptions = adResponse.data.return_data
                      this.accountSelect = adResponse.data.selecded_data
                      this.selecdedCurrency =  adResponse.data.selecded_currency

                      this.createText = this.showLang[this.selectLang]['views']['TargetList']['create_campaign_button_text'];
                      this.isUes = false;

                      if(this.dataType == 'tiktok'){
                        this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                      }

                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          advertiser_id: this.accountSelect,
                        }))
                        .then((caResponse) => {
                          // console.log('caResponse:'+caResponse.data.return_data);
                          if(caResponse.data.status == 'success'){
                            this.campaignListData = caResponse.data.return_data
                          }

                          this.showTable = true;
                        });

                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['swal_title'],
                        text: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['swal_text'],
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['confirm_button']
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                        } else if (result.isDenied) {
                          window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                        }
                      })
                    }
                  }
                });
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
              text: adResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });


    } else {
      Swal.fire({
        icon: 'error',
        title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
        text: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_text'],
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
        // denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // Swal.fire('Saved!', '', 'success')
          // this.allPageLoading = true
          window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
        } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
          // this.allPageLoading = true
          window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
        }
      })
    }
  },
  watch:{
    'getFirstLoginStatus': function(v){
      console.log('watch getFirstLoginStatus');
      console.log(v);
      if(v.data.return_data.first_login != '' && v.data.return_data.first_login != null && typeof v.data.return_data.first_login != undefined){
        if(v.data.return_data.first_login == 'Y'){
          axios
            .post('https://test.autoturn.net/inside/api/target/campaign/campaign_list.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.accountSelect,
            }))
            .then((caResponse) => {
              // console.log('caResponse:'+caResponse.data.return_data);
              if(caResponse.data.status == 'success'){
                this.campaignListData = caResponse.data.return_data
              }
            });

          this.nowStep = 7;
        }
      }
    },
    fromAccountSelect(v){
      console.log('fromAccountSelect');
      console.log(v);

      this.dataType = v

      let hash = this.$route.params.id;

      let routeType = 'f';
      document.title = '標靶活動列表 - AutoTurn';
      // if(v == 'tiktok'){
      //   routeType = 't';
      //   document.title = this.showLang[this.selectLang]['views']['List']['tiktok_page_name']+' - AutoTurn';
      // }

      this.$router.push({ params: { type: routeType }});

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        console.log('props this.getFirstLoginStatusData');
        console.log(this.getFirstLoginStatusData);

        axios
          .post('https://test.autoturn.net/inside/api/member_campaign_use_num.php', Qs.stringify({
            s_code: hash,
            type: v
          }))
          .then((response) => {
            // console.log('caResponse:'+caResponse.data.return_data);
            if(response.data.status == 'success'){
              this.run_info = response.data.return_data
            }
          });

        if(v == 'facebook'){
          axios
            .post('https://test.autoturn.net/inside/api/campaign_adaccounts.php', Qs.stringify({
              s_code: hash,
              adaccount_id: this.$route.params.adaccount_id,
            }))
            .then((adResponse) => {
              // console.log('adResponse:'+adResponse.data.selecded_data);
              if(adResponse.data.status == 'success'){
                if(adResponse.data.return_data.length > 0){
                  this.accountOptions = adResponse.data.return_data
                  this.accountSelect = adResponse.data.selecded_data
                  this.selecdedCurrency =  adResponse.data.selecded_currency

                  console.log('list campaign_adaccounts this.selecdedCurrency');
                  console.log(this.selecdedCurrency);

                  this.createText = this.showLang[this.selectLang]['views']['TargetList']['create_campaign_button_text'];
                  this.isUes = false;

                  if(this.dataType == 'tiktok'){
                    this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                  }

                  axios
                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_list.php', Qs.stringify({
                      s_code: hash,
                      adaccount_id: adResponse.data.selecded_data,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      if(caResponse.data.status == 'success'){
                        this.campaignListData = caResponse.data.return_data
                      }

                      this.showTable = true;
                    });
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['confirm_button']
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                    } else if (result.isDenied) {
                      window.location.href = "https://dev-private.autoturn.net/"+routeType+"/"+hash;
                    }
                  })
                }
              }
            });
        } else {
          axios
            .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
              s_code: hash,
              advertiser_id: this.$route.params.adaccount_id,
            }))
            .then((adResponse) => {
              // console.log('adResponse:'+adResponse.data.selecded_data);
              if(adResponse.data.status == 'success'){
                if(adResponse.data.return_data.length > 0){
                  this.accountOptions = adResponse.data.return_data
                  this.accountSelect = adResponse.data.selecded_data
                  this.selecdedCurrency =  adResponse.data.selecded_currency

                  console.log('list tiktok_campaign_adaccounts this.selecdedCurrency');
                  console.log(this.selecdedCurrency);

                  this.createText = this.showLang[this.selectLang]['views']['TargetList']['create_campaign_button_text'];
                  this.isUes = false;

                  if(this.dataType == 'tiktok'){
                    this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                  }

                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                      s_code: hash,
                      advertiser_id: this.accountSelect,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      if(caResponse.data.status == 'success'){
                        this.campaignListData = caResponse.data.return_data
                      }

                      this.showTable = true;
                    });
                }
              }
            });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
          text: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    }
  },
  methods: {
    toggleBlock(index) {
      console.log('toggleBlock', index);
      // this.showBlock = !this.showBlock;
      this.campaignList[index].status = !this.campaignList[index].status;
    },
    toggleBudget() {
      this.showBudget = !this.showBudget;
    },
    toggleKeyword() {
      this.showKeyword = !this.showKeyword;
    },
    useLang(v){
      console.log('list methods useLang');
      console.log(v);

      if(v == '' || v == null || typeof v == 'undefined'){
        v = 'zh-TW';
      }

      this.selectLang = v

      this.$emit('childLang', v);

      console.log('this.selectLang');
      console.log(this.selectLang);
      // console.log('showLang['+v+'][msg]');
      // console.log(this.showLang[v]['msg']);

      document.title = '標靶活動列表 - AutoTurn';
      // if(this.dataType == 'tiktok'){
      //   document.title = this.showLang[this.selectLang]['views']['List']['tiktok_page_name']+' - AutoTurn';
      // }
    },
    onCancel(){
      // console.log('onCancel');
      this.allLoading = false;
    },
    campaign(value){
      console.log('campaign');
      console.log(this.fromAccountSelect);
      this.showChart = false;
      this.showCloud = false;
      this.showTable = false;

      if(this.fromAccountSelect == 'facebook'){
        axios
          .post('https://test.autoturn.net/inside/api/campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((adResponse) => {
            if(adResponse.data.status == 'success'){
              this.selecdedCurrency =  adResponse.data.selecded_currency
            }
          });

        axios
          .post('https://test.autoturn.net/inside/api/target/campaign/campaign_list.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((caResponse) => {
            // console.log(caResponse.data);
            if(caResponse.data.status == 'success'){
              this.campaignListData = caResponse.data.return_data
            }

            this.showTable = true;
          });
      } else {
        axios
          .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: value,
          }))
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            if(adResponse.data.status == 'success'){
              if(adResponse.data.return_data.length > 0){
                // this.accountOptions = adResponse.data.return_data
                // this.accountSelect = adResponse.data.selecded_data
                this.selecdedCurrency =  adResponse.data.selecded_currency

                // this.createText = this.showLang[this.selectLang]['views']['TargetList']['create_campaign_button_text'];
                // this.isUes = false;

                axios
                  .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser_id: value,
                  }))
                  .then((caResponse) => {
                    // console.log('caResponse:'+caResponse.data.return_data);
                    if(caResponse.data.status == 'success'){
                      this.campaignListData = caResponse.data.return_data
                    }

                    this.showTable = true;
                  });
              }
            }
          });
      }
    },
    createCampaign(){
      let member_hash = this.$route.params.id
      let adaccount_id = this.$route.params.adaccount_id

      axios
        .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'add',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/target-events-list/"+this.$route.params.type+"/"+member_hash+"/"+this.accountSelect;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/target-events-list/"+this.$route.params.type+"/"+member_hash+"/"+this.accountSelect;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              axios
                .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  status: 'N',
                }))
                .then((adResponse) => {
                  if(this.fromAccountSelect == 'facebook'){
                    window.location.href = "https://dev-private.autoturn.net/target-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.accountSelect;
                  } else {
                    window.location.href = "https://dev-private.autoturn.net/event-add-tiktok/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.accountSelect;
                  }
                });
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                status: 'N',
              }))
              .then((adResponse) => {
                if(this.fromAccountSelect == 'facebook'){
                  window.location.href = "https://dev-private.autoturn.net/target-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.accountSelect;
                } else {
                  window.location.href = "https://dev-private.autoturn.net/event-add-tiktok/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.accountSelect;
                }
              });
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_title'],
              text: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    nextStep() {
      this.nowStep = this.nowStep + 1;      
      console.log('list this.nextStep');
      console.log(this.nowStep);

      if(this.nowStep == 9 && this.member_source == 6){
        this.nowStep = 90;

        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 9){
        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 10) {
        this.$refs.scrollcontent.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    closeTips() {        
      this.nowStep = -1;
      console.log('closeTips');
      console.log(this.nowStep);

      axios
        .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          status: 'N',
        }))
        .then((adResponse) => {});
    },
    getTransmitTiktokNum(v){
      console.log('watch getTransmitTiktokNum');
      console.log(v);
      console.log(this.transmitTiktokNum);
      this.transmitTiktokNum = v;
      console.log(this.transmitTiktokNum);
    },
    doCloseForTeaching(){
      console.log('list doCloseForTeaching');
      this.nowStep = -1;

      axios
        .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          status: 'N',
        }))
        .then((adResponse) => {});
    }
  },
  mounted () {
    // document.title = '行銷活動列表 - AutoTurn';
  },
  computed: {
    getFirstLoginStatusData: {
      get: function () {
        return this.getFirstLoginStatus
      },
      set: function (value) {
        this.$emit('update:getFirstLoginStatusData', value)
      },
    },
  }
}

</script>

<style lang="scss" scoped>

</style>
<style>
.bot-fab {
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 45px;
    height: 45px;
    background: #2563eb;
    border-radius: 50%;
    box-shadow: 0 2px 12px #0002;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1001;
    /*animation: botBounce 5s infinite;*/
}
.bot-fab svg {
    width: 30px;
    height: 30px;
    color: #fff;
}
.bot-fab .red-dot {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 16px;
    height: 16px;
    background: #ef4444;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 0 0 4px #fff;
    display: block;
    animation: redDotBlink 4s infinite;
}
@keyframes botBounce {
    0%, 100% { transform: scale(1) translateY(0); }
    20% { transform: scale(1.08) translateY(-6px); }
    40% { transform: scale(0.98) translateY(2px); }
    60% { transform: scale(1.05) translateY(-4px); }
    80% { transform: scale(1) translateY(0); }
}
@keyframes redDotBlink {
    0%, 100% { opacity: 1; box-shadow: 0 0 12px 4px #ef4444aa; }
    50% { opacity: 0.5; box-shadow: 0 0 24px 8px #ef4444cc; }
}
</style>